import $ from 'jquery'
import 'foundation-sites'
import Vue, { DirectiveOptions, VNode, VNodeDirective } from 'vue'

/**
 * Foundation の機能を有効化するディレクティブ。
 *
 * 多用し過ぎるとブラウザのパフォーマンスが酷く低下するので、画面1つにつき1回までの使用を強く推奨する。
 * 特にIE11でパフォーマンスの低下が顕著である。（#63893）
 *
 * 動的にコンテンツが変化して再度 foundation のバインドが必要になるケースがある場合、
 * foundation を使用せず Vue の機能だけで UI を構築すること。
 */
const options: DirectiveOptions = {
  bind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
    Vue.nextTick()
      .then(() => {
        $(el).foundation()
      })
  },
  unbind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
    const zfPlugin = $(el).data('zfPlugin')
    try {
      $(el).foundation('destroy')
    } catch (e) {
      // Foundation の Toggler 等は zfPlugin というデータを持たないためか、 destroy 時にエラーが発生してしまう。
      // （Foundation のバグ？）
      // 毎回エラーが出るのは困るので、 zfPlugin を持たない場合のみエラーの発生を抑止する。
      if (!!zfPlugin) {
        console.error(e)
      }
    }
  }
}

export default options
